module.exports = __webpack_public_path__ + "static/hero_sp_lan-9c24551ca9ce57949845caf7be14af80.png";